<template>
  <AccountsExpansionPanelWrapper>
    <template #panels>
      <AccountsExpansionPanelRow
        v-for="account in accounts"
        :key="account.id"
        :account="account"
        @row-selected="selectedAccountId = $event"
        @get-accounts="$emit('get-accounts', $event)"
        @show-delete-dialog="showRemoveAccountDialog"
      >
        <template #account-type>
          <GooglePlayIcon />{{ $t("message.mobile.common.addApp") }}
        </template>
        <template #add-btn>
          <ui-button
            color="primary"
            outlined
            icon="icon-plus"
            @click.stop="handleAddAccount(account.id)"
          >
            {{ $t("message.mobile.common.addApp") }}
          </ui-button>
        </template>
        <template #items-list v-if="account.apps.length > 0">
          <ExpansionListItem
            v-for="app in account.apps"
            :key="app.id"
            :item="app"
          >
            <template #actions>
              <ui-button
                @click="handleDeleteApp(app.id)"
                icon="icon-trash"
                iconColor="red"
              >
                {{ $t("message.mobile.common.appDeleteAlert.btnText") }}
              </ui-button>
            </template>
          </ExpansionListItem>
        </template>
        <template #items-list v-else>
          <ExpansionListItem
            :item="{ name: $t('message.mobile.common.noApps') }"
          />
        </template>
      </AccountsExpansionPanelRow>
      <SectionLoader v-if="loading" :status="loading" :opacity="1" />
    </template>
    <template>
      <AlertDialog
        v-if="currentAlertDialog.visible"
        v-bind="alertDialogProps"
        @close="closeDialog"
        @confirm="currentAlertDialog.confirmAction"
      />
      <AddAppDialog
        v-if="addAppDialogVisible"
        @close="addAppDialogVisible = false"
        @app-added="fetchApps"
        :selectedAccountId="selectedAccountId"
      />
      <AlertDialog
        v-if="showRemoveItemDialog"
        :title="$t('message.mobile.common.appDeleteAlert.title')"
        :description="$t('message.mobile.common.appDeleteAlert.description')"
        @close="showRemoveItemDialog = false"
        @confirm="deleteApp"
      />
    </template>
  </AccountsExpansionPanelWrapper>
</template>

<script>
const DEFAULT_ALERT_DATA = Object.freeze({
  visible: false,
  title: "",
  description: "",
  confirmAction: null
});
import AccountsExpansionPanelWrapper from "@/components/ExpansionPanels/AccountsExpansionPanelWrapper.vue";
import AccountsExpansionPanelRow from "@/components/ExpansionPanels/AccountsExpansionPanelRow.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import GooglePlayIcon from "@/components/ui/Icons/GooglePlayIcon.vue";
import AddAppDialog from "@/components/GooglePlay/AddAppDialog.vue";
import ExpansionListItem from "@/components/ExpansionPanels/ExpansionListItem.vue";
import googlePlayService from "@/services/googlePlay";
export default {
  name: "AccountsExpansionPanel",
  components: {
    AccountsExpansionPanelWrapper,
    AccountsExpansionPanelRow,
    SectionLoader,
    GooglePlayIcon,
    AddAppDialog,
    ExpansionListItem,
    AlertDialog: () => import("@/components/FacebookAccounts/AlertDialog.vue")
  },
  props: {
    accounts: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectPageDialogVisible: false,
      addAppDialogVisible: false,
      selectedAccountId: null,
      selectedAppId: null,
      showRemoveItemDialog: false,
      currentAlertDialog: DEFAULT_ALERT_DATA
    };
  },
  methods: {
    showRemoveAccountDialog(accountId) {
      this.currentAlertDialog = {
        visible: true,
        title: this.$t(
          "message.mobile.googlePlay.listings.accountRemoveAlert.title"
        ),
        description: this.$t(
          "message.mobile.googlePlay.listings.accountRemoveAlert.description"
        ),
        confirmAction: () => {
          this.deleteAccount(accountId);
        }
      };
    },
    closeDialog() {
      this.currentAlertDialog = DEFAULT_ALERT_DATA;
    },
    async deleteAccount(accountId) {
      this.$emit("delete-account", accountId);
      this.closeDialog();
    },
    handleAddAccount(accountId) {
      this.addAppDialogVisible = true;
      this.selectedAccountId = accountId;
    },
    handleDeleteApp(appId) {
      this.selectedAppId = appId;
      this.showRemoveItemDialog = true;
    },
    async deleteApp() {
      await googlePlayService.deleteApp(this.selectedAppId);
      this.showRemoveItemDialog = false;
      this.fetchApps(this.selectedAccountId);
    },
    async fetchApps(accountId) {
      const { data } = await googlePlayService.getApps(accountId);
      const account = this.accounts.find(acc => acc.id === accountId);
      this.$set(account, "apps", data);
    }
  },
  computed: {
    alertDialogProps() {
      return {
        title: this.currentAlertDialog.title,
        description: this.currentAlertDialog.description,
        cancelBtnText: this.currentAlertDialog.cancelBtnText,
        confirmBtnText: this.currentAlertDialog.confirmBtnText
      };
    }
  }
};
</script>
